import { useEffect, useState } from "react";
import { Badge, Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";
import Swal from "sweetalert2";

const ConnectedConditionalFormField = ({
  Show,
  Hide,
  Title,
  activeTabName,
  formId,
  version,
  formType,
  dataEntryType,
  recordId,
  connectedConditionalFormList,
  connectedConditionalFormLoader,
  getStudyConnectedFormList,
  getStudyConnectedFormFields,
}) => {
  const [actionEventId, setActionEventId] = useState("");
  const [actionTimePointUniqueId, setActionTimePointUniqueId] = useState("");

  const [actionFormId, setActionFormId] = useState("");
  const [actionFormVersion, setActionFormVersion] = useState("");

  const [actionFieldId, setActionFieldId] = useState("");

  const [actionOptionId, setActionOptionId] = useState("");

  const [loader, setLoader] = useState(false);

  const [eventList, setEventList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [fieldList, setFieldList] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const handleChange = (name, value) => {
    switch (name) {
      case "event":
        const [eventId, timePointUniqueId] =
          value.split("___");
        setActionEventId(eventId);
        setActionTimePointUniqueId(
          timePointUniqueId || ""
        );
        setActionFormId("");
        setActionFormVersion("");
        setActionFieldId("");
        setActionOptionId("");
        break;

      case "form":
        const [formId, formVersion] =
          value.split("___");
        setActionFormId(formId);
        setActionFormVersion(formVersion);
        setActionFieldId("");
        setActionOptionId("");
        break;

      case "field":
        setActionFieldId(value);
        setActionOptionId("");
        break;

      case "option":
        setActionOptionId(value);
        break;

      default:
        break;
    }
  };

  const studyConnectFormWithFieldOption = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Connect this form with form field!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Connect it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.mode = StudyMode
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.actionEventId = actionEventId
        if (actionTimePointUniqueId) {
          userData.actionTimePointUniqueId = actionTimePointUniqueId
        }
        userData.actionFormId = actionFormId
        userData.actionFormVersion = actionFormVersion
        userData.actionFieldId = actionFieldId
        userData.actionOptionId = actionOptionId
        userData.targetEventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.targetTimePointUniqueId = activeTabName?.timePointUniqueId
        }
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        userData.targetFormId = formId
        userData.targetFormVersion = version
        userData.targetFormType = formType
        userData.targetDataEntryType = dataEntryType
        if (recordId) {
          userData.targetRecordId = recordId
        }
        let data = await studySiteDataEntryServices.studyConnectFormWithFieldOption(userData)
        if (data?.statusCode === 200) {
          getStudyConnectedFormList()
          getStudyConnectedFormFields()
          setActionEventId("");
          setActionTimePointUniqueId("");
          setActionFormId("");
          setActionFormVersion("");
          setActionFieldId("");
          setActionOptionId("");
          Hide()
        }
        setLoader(false)
      };
    })
  };

  useEffect(() => {
    if (connectedConditionalFormList?.length > 0) {
      const eventTimePointList = [
        ...new Map(
          connectedConditionalFormList?.map((item) => [
            `${item.eventId}_${item.timePointUniqueId || ""}`,
            {
              eventId: item.eventId,
              eventName: item.eventName,
              timePointUniqueId:
                item.timePointUniqueId || "",
              timePointId:
                item.timePointId || "",
            },
          ])
        )?.values(),
      ];

      setEventList(eventTimePointList);
    } else {
      setEventList([]);
    }
  }, [connectedConditionalFormList]);

  useEffect(() => {
    if (!actionEventId) {
      setFormList([]);
      return;
    }

    const forms = [
      ...new Map(
        connectedConditionalFormList
          ?.filter(
            (item) =>
              item.eventId === actionEventId &&
              (item.timePointUniqueId || "") ===
              actionTimePointUniqueId
          )
          .map((item) => [
            `${item.formId}_${item.formVersion}`,
            {
              formId: item.formId,
              formName: item.formName,
              formVersion: item.formVersion,
            },
          ])
      )?.values(),
    ];

    setFormList(forms);
  }, [
    actionEventId,
    actionTimePointUniqueId,
    connectedConditionalFormList,
  ]);

  useEffect(() => {
    if (!actionFormId) {
      setFieldList([]);
      return;
    }

    const fields = [
      ...new Map(
        connectedConditionalFormList
          ?.filter(
            (item) =>
              item.eventId === actionEventId &&
              item.formId === actionFormId &&
              item.formVersion ===
              actionFormVersion &&
              (item.timePointUniqueId || "") ===
              actionTimePointUniqueId
          )
          .map((item) => [
            item.fieldId,
            {
              fieldId: item.fieldId,
              fieldName: item.fieldName,
            },
          ])
      )?.values(),
    ];

    setFieldList(fields);
  }, [
    actionEventId,
    actionTimePointUniqueId,
    actionFormId,
    actionFormVersion,
    connectedConditionalFormList,
  ]);

  useEffect(() => {
    if (!actionFieldId) {
      setOptionList([]);
      return;
    }

    const options = [
      ...new Map(
        connectedConditionalFormList
          ?.filter(
            (item) =>
              item.eventId === actionEventId &&
              item.formId === actionFormId &&
              item.formVersion ===
              actionFormVersion &&
              String(item.fieldId) === String(actionFieldId) &&
              (item.timePointUniqueId || "") ===
              actionTimePointUniqueId
          )
          .map((item) => [
            item.optionId,
            {
              optionId: item.optionId,
              optionName: item.optionName,
            },
          ])
      )?.values(),
    ];

    setOptionList(options);
  }, [
    actionEventId,
    actionTimePointUniqueId,
    actionFormId,
    actionFormVersion,
    actionFieldId,
    connectedConditionalFormList,
  ]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1">Event (Time Point) <abbr title="Required" className="text-danger"> *</abbr></Form.Label>
          <Form.Select
            value={`${actionEventId}___${actionTimePointUniqueId}`}
            onChange={(e) =>
              handleChange("event", e.target.value)
            }
          >
            <option value="">
              Select Event
            </option>
            {eventList?.map((item) => (
              <option
                key={`${item.eventId}_${item.timePointUniqueId}`}
                value={`${item.eventId}___${item.timePointUniqueId}`}
              >
                {item.eventName}
                {item.timePointId
                  ? ` (${item.timePointId})`
                  : ""}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1">Form <abbr title="Required" className="text-danger"> *</abbr></Form.Label>
          <Form.Select
            disabled={!actionEventId}
            value={`${actionFormId}___${actionFormVersion}`}
            onChange={(e) =>
              handleChange("form", e.target.value)
            }
          >
            <option value="">
              Select Form
            </option>

            {formList?.map((item) => (
              <option
                key={`${item.formId}_${item.formVersion}`}
                value={`${item.formId}___${item.formVersion}`}
              >
                {item.formName} (V{item.formVersion})
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1">Field <abbr title="Required" className="text-danger"> *</abbr></Form.Label>
          <Form.Select
            disabled={!actionFormId}
            value={actionFieldId}
            onChange={(e) =>
              handleChange("field", e.target.value)
            }
          >
            <option value="">
              Select Field
            </option>

            {fieldList?.map((item) => (
              <option
                key={item.fieldId}
                value={item.fieldId}
              >
                {item.fieldName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1">Option <abbr title="Required" className="text-danger"> *</abbr></Form.Label>
          <Form.Select
            disabled={!actionFieldId}
            value={actionOptionId}
            onChange={(e) =>
              handleChange("option", e.target.value)
            }
          >
            <option value="">
              Select Option
            </option>

            {optionList?.map((item) => (
              <option
                key={item.optionId}
                value={item.optionId}
              >
                {item.optionName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          className="updateProfile"
          disabled={loader || !actionEventId || !actionFormId || !actionFormVersion || !actionFieldId || !actionOptionId}
          onClick={studyConnectFormWithFieldOption}
        >
          {loader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Connecting...
            </div>
          ) : (
            "Connect now"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default ConnectedConditionalFormField;